<capra-icon
  class="status-icon {{ status }}"
  attr.data-test="capra-status-icon-{{ status }}"
  [icon]="iconNameRecord[status]"
  width="{{ size }}px"
  height="{{ size }}px"
></capra-icon>
